import React from 'react';
import styles from '../Forms.module.scss';
import { IBlock } from 'database';

type ViewBlockFormProps = {
    defaultDetails: IBlock
}

const ViewBlockForm: React.FC<ViewBlockFormProps> = ({defaultDetails}) => {

    const values = {
            blockId: defaultDetails.blockId === null ? '' : defaultDetails.blockId,
            blockName: defaultDetails.name === null ? '' : defaultDetails.name,
            altBlockName: defaultDetails.altName === null ? '' : defaultDetails.altName,
            operationalStatus: defaultDetails.operationalStatus === null ? '' : defaultDetails.operationalStatus,
            elr: defaultDetails.elr === null ? '' : defaultDetails.elr,
            blockMileage: defaultDetails.mileage === null ? '' : defaultDetails.mileage,
            comments: ''
    };

    return (
        <div className={styles.Form}>
            <form>             
                <label htmlFor="blockName">Block Name</label>
                <input
                    readOnly
                    id="blockName"
                    name="blockName"
                    type="text"
                    value={values.blockName}
                />
                <label htmlFor="altBlockName">Alternative Block Name</label>
                <input
                    readOnly
                    id="altBlockName"
                    name="altBlockName"
                    type="text"
                    value={values.altBlockName}
                />
                <label htmlFor="elr">ELR</label>
                <input
                    readOnly
                    id="elr"
                    name="elr"
                    type="text"
                    value={values.elr}
                />
                <label htmlFor="blockMileage">Mileage</label>
                <input
                    readOnly
                    id="blockMileage"
                    name="blockMileage"
                    type="text"
                    value={values.blockMileage}
                />
            </form>
        </div>
    )
}

export default ViewBlockForm;